import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  content: {
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  links: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    paddingRight: 4,
    paddingLeft: 4,
  },
  label: {
    textTransform: 'uppercase',
    color: colors.darkestGray,
    marginBottom: theme.spacing(1),
  },
  labelValue: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));
